/**
 * @generated SignedSource<<c977cbba68d85a26294276c4eb0ce011>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type User_Management_Fragment$data = {
  readonly avatar: {
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly email: string | null | undefined;
  readonly firstName: string | null | undefined;
  readonly forms: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null | undefined;
  readonly id: string;
  readonly lastName: string | null | undefined;
  readonly meta: {
    readonly jobRole: string | null | undefined;
    readonly profileArticleLinks: ReadonlyArray<{
      readonly iconName: string | null | undefined;
      readonly name: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly profileImage: {
      readonly description: string | null | undefined;
      readonly id: string;
      readonly mediaDetails: {
        readonly sizes: ReadonlyArray<{
          readonly name: string | null | undefined;
          readonly sourceUrl: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly mediaItemUrl: string | null | undefined;
      readonly mimeType: string | null | undefined;
    } | null | undefined;
    readonly profileSocialLinks: ReadonlyArray<{
      readonly name: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly name: string | null | undefined;
  readonly nicename: string | null | undefined;
  readonly registeredDate: string | null | undefined;
  readonly role: string | null | undefined;
  readonly slug: string | null | undefined;
  readonly username: string | null | undefined;
  readonly znglists: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null | undefined;
  readonly znglyVideos: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null | undefined;
  readonly " $fragmentType": "User_Management_Fragment";
};
export type User_Management_Fragment$key = {
  readonly " $data"?: User_Management_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"User_Management_Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v4 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "stati": [
        "PUBLISH",
        "HIDDEN"
      ]
    }
  }
],
v5 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "User_Management_Fragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nicename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registeredDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": 10
        }
      ],
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": "avatar(size:10)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User_Meta",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jobRole",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MediaItem",
          "kind": "LinkedField",
          "name": "profileImage",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mediaItemUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mimeType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MediaDetails",
              "kind": "LinkedField",
              "name": "mediaDetails",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MediaSize",
                  "kind": "LinkedField",
                  "name": "sizes",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sourceUrl",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User_Meta_profileSocialLinks",
          "kind": "LinkedField",
          "name": "profileSocialLinks",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User_Meta_profileArticleLinks",
          "kind": "LinkedField",
          "name": "profileArticleLinks",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "iconName",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v4/*: any*/),
      "concreteType": "UserToZnglyVideoConnection",
      "kind": "LinkedField",
      "name": "znglyVideos",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ZnglyVideo",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v5/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "znglyVideos(first:1,where:{\"stati\":[\"PUBLISH\",\"HIDDEN\"]})"
    },
    {
      "alias": null,
      "args": [
        (v3/*: any*/)
      ],
      "concreteType": "UserToFormConnection",
      "kind": "LinkedField",
      "name": "forms",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Form",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v5/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "forms(first:1)"
    },
    {
      "alias": null,
      "args": (v4/*: any*/),
      "concreteType": "UserToZnglistConnection",
      "kind": "LinkedField",
      "name": "znglists",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Znglist",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v5/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "znglists(first:1,where:{\"stati\":[\"PUBLISH\",\"HIDDEN\"]})"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "914208d56d582ddae06d050ce95e9f9f";

export default node;
